// extracted by mini-css-extract-plugin
module.exports = {"list":"InvoiceReasons_list__YO93z","item":"InvoiceReasons_item__SCWcP","item__figure":"InvoiceReasons_item__figure__NdPBq","item__title":"InvoiceReasons_item__title__CMOj8"};